/*
Usage Notes:

The following web component can be dropped into any standard Shopify theme (i.e. non-headless), using Liquid to pass product data:

  {% assign skioSellingPlanGroups = product.selling_plan_groups | where: 'app_id', 'SKIO' %}
  {% if skioSellingPlanGroups.size > 0 %}
    <skio-plan-picker
      product='{{ product | json | escape }}'
      selectedVariant='{{ product.selected_or_first_available_variant | json | escape }}'
      formId='{{ product_form_id }}'
      currency='{{ cart.currency.iso_code }}'
      >
    </skio-plan-picker>
    <script src="{{ 'skio-plan-picker-component.js' | asset_url }}" type="module"></script>
    {% render 'skio-details' %}
  {% endif %}

  Note: formId not required if element is inside of a form already

  Example variantChanged event dispatch:
  document.dispatchEvent( new CustomEvent("variantChanged", { detail: { variantId: variant.id } }) );
*/

import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js'

const skioStyles = css`
  .skio-plan-picker {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0;
    border: 0;

  }
  .skio-onetime-second {
    order: 2;
  }
  
  .skio-group-container {
    display: none;
  }
  .skio-group-container--available {
    display: block;
    position: relative;
    border-radius:26px;
    border: 1px solid #DBDFEA;
    background-color: #fff;
    transition: background-color 0.2s ease;   
    color: #2e3138;
  }

  .skio-group-input {
    position: absolute;
    width: 0px;
    height: 0px;
    opacity: 0;
  }
  .skio-group-input:focus-visible ~ .skio-group-label {
    outline: 2px #ccc solid;
    outline-offset: 4px;
    border-radius: 5px;
  }
  
  .skio-group-label {
    font-family: var(--font-secondary);
    color:#949EB0;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    padding: 16px 17px;
    overflow: hidden;
  }

  .skio-group-container--selected .skio-group-topline {
    color: #2A4189!important;
  }

  .skio-group-container--selected {
    background-color: #ebedff;
    border: 2px solid #2A4189;
  }

  .skio-group-topline {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    font-size: 16px;
  }
  
  .skio-radio__container {
    display: none;
    margin-right: 10px;
  }

  .skio-radio__container svg circle:first-child {
    stroke: #b0b7f1;
    stroke-width: 2px;
    transition: fill 0.2s ease;
  }

  .skio-group-container--selected .skio-radio__container svg circle:first-child {
    fill: #b0b7f1;
  }
  
  .skio-radio {
    transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    transform-origin: center;
    transform: scale(0);
    opacity: 0;
  }
  .skio-group-label:hover .skio-radio {
    transform: scale(1);
    opacity: 0.75;
  }
  .skio-group-container--selected .skio-group-label .skio-radio {
    transform: scale(1);
    opacity: 1;
  }
  
  .skio-price {
    margin-left: auto;
  }
  
  .skio-group-content {
    width: auto;
    transition: max-height 0.25s cubic-bezier(0.4,0,0.2,1),
                opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    max-height: 38px;
    opacity: 1;
  }
  
  /* Hide frequency if not selected */
  .skio-group-container:not(.skio-group-container--selected) .skio-group-content {
    max-height: 0;
    opacity: 0;
    pointer-events: none;
  }
  
  .skio-group-title {
    min-width: max-content;
  }
  
  .skio-save {
    /* color: #0fa573;
    border: 1px #0fa573 solid; 
    padding: 0px 8px;
    border-radius: 20px; */
  }
  
  .skio-frequency {
    color: #59616E;
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 8px 30px 8px 10px;
    margin-top: 6px;
    border-radius: 5px;
    background-color: #ffffff;
    width: 100%;
    border: 0;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-position: right 10px top 50%;
    background-size: 18px;
    background-repeat: no-repeat;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    line-height: 18px; 
  }
  .skio-frequency.skio-frequency--one {
    background-image: none;
  }
  
  .skio-frequency span {
    text-transform: lowercase;
  }

  button.add-to-cart {
    justify-content: center;
    font-weight: 400;
    text-transform: capitalize;
    letter-spacing: 0;
    font-style: normal;
    font-size: 16px;
    text-decoration: none;
    box-shadow: 0 0 #0000004d inset;
    width: 100%;
    color: #fff;
    background-color: #5f3ebc;
    border-radius: 5px;
    transition-duration: .3s;
    padding: 10px 32px;
    text-transform: uppercase;
    cursor: pointer;
    font-family: 'FK Grotesk Neue Trial';
    transition: border-color 0.25s ease, background-color 0.25s ease, color 0.25s ease;

    border: solid 2px rgba(0,0,0,0);
  }
  button.add-to-cart:hover {
    background-color: rgba(0,0,0,0);
    color: #5f3ebc;
    border-color: #5f3ebc;
  }

  .skio-details {
    --text-color: #333;
    --text-color-secondary: #888; 
    
    user-select: none;
    -webkit-user-select: none;
    margin-bottom: 20px;
    margin-top: 10px;
  }

  .skio-details summary::-webkit-details-marker,
  .skio-details summary::marker {
    display: none;
    color: #fff !important;
  }

  .skio-details summary span {
    font-size: 0.9em;
    display: flex;
    padding: .5em 0;
    cursor: pointer;
    align-items: center;
    gap: 10px;
    text-decoration: underline;

    margin-top: -40px;
    color: #5f3ebc;
  }

  @keyframes fadeInDown {
    0% {
      opacity: 0;
      transform: translateY(-15px);
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }
  .skio-details[open] > .skio-details--content {
    animation-name: fadeInDown;
    animation-duration: 0.3s;
  }

  .skio-details--content {
    position: absolute;
    z-index: 1020;
    padding: 1em;
    width: fit-content;
    border-radius: 5px;
    background: white;
    box-shadow: 0 0 5px rgb(23 24 24 / 5%), 0 1px 2px rgb(0 0 0 / 7%);
  }

  .skio-details ul {
    margin: 0;
    padding: 0;
  }

  .skio-details ul li {
    display: flex;
    align-items: flex-start;
    gap: .75em;

    margin-bottom: 1em;
  }

  .skio-details .skio-content {
    display: flex;
    flex-direction: column;
  }

  .skio-details .skio-content p {
    font-size: 0.9em;

    margin-top: 0;
    margin-bottom: 0;

    letter-spacing: 0;
    line-height: 1.5;

    color: var(--text-color);
  }

  .skio-details ul li small {
    font-size: 0.7em;
    color: var(--text-color-secondary);
  }

  .skio-details .skio-icon {
    display: flex;

    width: 2.25em;
    height: 2.25em;

    color: var(--text-color);
    background: #f8f8f8;
    border-radius: 100%;

    flex-shrink: 0;
    align-items: center;
    justify-content: center;
  }

  .skio-details .skio-icon svg {
    width: 1.25em;
    height: 1.25em;

    color: inherit;
  }

  .skio-details--footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.9em;
  }

  .skio-details--footer a {
    color: var(--text-color);
  }

  .skio-manage-link {
    text-decoration: underline;
  }

  .powered-by-skio {
    font-size: 0.8em;

    display: flex;
    text-decoration: none;
    
    align-items: center;
    gap: 3px;
  }
  .skio-price>span{
    position: relative;
    margin-right: 20px;
    font-family: var(--font-primary);
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: -.01em;
  }
  .decimals{
    position: absolute;
    font-size: 10px;
    top: -.8em;
    left: 100%;
  }

`

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    product: { type: Object }, // required
    productHandle: { type: String }, // optional (unless product isn't passed, then required)
    key: { type: String }, // optional, defaults to product.id; identifier for this instance of the Skio plan picker

    formId: { type: String }, // optional; if passed, used to connect input fields to form
    needsFormId: { type: Boolean }, // optional, defaults to false; if true, element needs to be passed a formId, else it searches for a form
    isMobile: { type: Boolean },

    subscriptionFirst: { type: Boolean }, // optional, defaults to false; if true, shows subscription option above onetime
    startSubscription: { type: Boolean }, // optional, defaults to false; if true, auto-selects subscription on page load
    discountFormat: { type: String }, // optional, defaults to percent; can also pass "fixed"

    currency: { type: String }, // optional, defaults to 'USD', but can pass any 3 char identifier
    language: { type: String }, // optional, defaults to 'en-US', but can pass any similarly formatted language identifier
    moneyFormatter: {}, // placeholder for object

    externalPriceSelector: { type: String }, // optional, used to update the external price

    externalPriceSelectorWithCurrency: { type: String }, // optional, used to update the external price

    selectedVariant: { type: Object }, // placeholder for data
    skioSellingPlanGroups: {}, // placeholder for data
    availableSellingPlanGroups: {}, // placeholder for data
    selectedSellingPlanGroup: {}, // placeholder for data
    selectedSellingPlan: {}, // placeholder for data
    selectedSellingPlanId: {}, // placeholder for data

    defaultFrequency: {}, // placeholder for data

    showAddToCartButton: { type: Boolean },

    meta: {}
  }

  static styles = skioStyles

  constructor () {
    super()
    this.product = null
    this.isMobile = false
    this.selectedVariant = null

    this.productHandle = null

    this.purchaseOption = 'onetime'

    this.key = null
    this.formId = null
    this.needsFormId = false

    this.skioSellingPlanGroups = []
    this.availableSellingPlanGroups = []

    this.selectedSellingPlanGroup = null
    this.selectedSellingPlan = null
    this.selectedSellingPlanId = null

    this.startSubscription = false
    this.subscriptionFirst = false

    this.skioMainProduct = true

    this.discountFormat = 'percent'

    this.externalPriceSelector = '[skio-external-price]'

    this.externalPriceSelectorWithCurrency = '[skio-external-price-with-currency]'

    this.currency = 'USD'
    this.language = 'en-US'
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: this.currency
    })

    this.defaultFrequency = null

    this.showAddToCartButton = false

    this.meta = {}
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.startSubscription === true) {
      this.purchaseOption = 'subscription'
    }

    if (!this.product && this.productHandle) {
      this.fetchProduct(this.productHandle)
    }

    if (this.needsFormId && this.formId === null) {
      const forms = document.querySelectorAll('form[action="/cart/add"]')
      if (forms.length > 0) {
        let form
        forms.forEach((el) => {
          if (el.hasAttribute('skio-key')) {
            if (el.getAttribute('skio-key') === this.key) form = el
          }
        })
        if (!form) form = forms[0]
        this.formId = form.id
        this.requestUpdate()
      }
    }
    const skio = this
    document.addEventListener('updatePrice', function (e) {
      skio.updateExternalPrice()
    })
    document.addEventListener('variantChanged', function (e) {
      // update variant id
      const variantId = e.detail.variantId
      const variant = skio.product.variants.find(x => x.id === variantId)
      if (variant) skio.selectedVariant = variant
      else skio.log('Unable to find variant with id: ', variantId)
      skio.requestUpdate()
    })

    if (this.meta !== '') this.meta = JSON.parse(this.meta)

    if (this.meta !== '') {
      // overwrite Add to cart button functionality
      const form = document.querySelector(`#${this.formId}`)
      if (form) {
        const atc = form.querySelector('button[name="add"][type="submit"]')
        if (atc) {
          atc.removeAttribute('type')
          atc.addEventListener('click', function (e) {
            e.stopPropagation()
            e.stopImmediatePropagation()
            e.preventDefault()
            // add to cart with the metas

            skio.addToCartMeta()
          })
        }
      }
    }

    if (!this.isMobile) {
      const skioSticky = document.querySelector('skio-plan-picker-add-to-cart')
      if (skioSticky) {
        skioSticky.addEventListener('skio-sticky-select-selling-plan-group', function (e) {
          if (e.detail.group === null) {
            skio.selectSellingPlanGroup(null, false)
          } else {
            skio.selectSellingPlanGroup(e.detail.group, false)
            skio.selectSellingPlan(e.detail.selling_plan, e.detail.group, false)
          }
        })
      }

      const SkioStickyMobile = document.querySelectorAll('skio-plan-picker')
      if (SkioStickyMobile) {
        SkioStickyMobile.forEach((option) => {
          option.addEventListener('skio-sticky-mobile-select-selling-plan-group', function (e) {
            if (e.detail.group === null) {
              skio.selectSellingPlanGroup(null, false)
            } else {
              skio.selectSellingPlanGroup(e.detail.group, false)
              skio.selectSellingPlan(e.detail.selling_plan, e.detail.group, false)
            }
          })
        })
      }
    } else {
      const SkioPDP = document.querySelectorAll('skio-plan-picker')
      SkioPDP.forEach((option) => {
        option.addEventListener('skio-pdp-select-selling-plan-group', function (e) {
          if (e.detail.group === null) {
            skio.selectSellingPlanGroup(null, false)
          } else {
            skio.selectSellingPlanGroup(e.detail.group, false)
            skio.selectSellingPlan(e.detail.selling_plan, e.detail.group, false)
          }
        })
      })
      // if it's mobile we receive the pdp skio readings
    }

    if (!this.isMobile) {
      setTimeout(() => {
        const initalizePlanGroup = new CustomEvent('skio-pdp-select-selling-plan-group', {
          detail: { group: this.selectedSellingPlanGroup, selling_plan: this.selectedSellingPlan },
          bubbles: true,
          composed: true
        })
        this.dispatchEvent(initalizePlanGroup)
      }, 500)
    }
  }

  render () {
    if (!this.product || !this.selectedVariant || this.skioSellingPlanGroups.length === 0 || this.meta !== '') return
    return html`
      <fieldset class="skio-plan-picker" skio-plan-picker="${this.key}">
        <input ${this.formId !== null ? html`form="${this.formId}"` : ''} name="selling_plan" type="hidden" value="${this.selectedSellingPlan !== null ? this.selectedSellingPlan?.id : ''}" />
        <input ${this.formId !== null ? html`form="${this.formId}"` : ''} name="properties[Discount]" type="hidden" value="${this.selectedSellingPlan !== null ? this.discount(this.selectedSellingPlan).percent : ''}" 
          ?disabled="${this.selectedSellingPlan === null}" />
        
        <div class="skio-group-container ${this.product.requires_selling_plan === false ? 'skio-group-container--available' : ''} ${this.selectedSellingPlanGroup === null ? 'skio-group-container--selected' : ''} ${this.subscriptionFirst ? 'skio-onetime-second' : ''}" skio-group-container 
          @click=${() => this.selectSellingPlanGroup(null)} >
        
          <input id="skio-one-time-${this.key}" class="skio-group-input" name="skio-group-${this.key}" type="radio" value="" 
            skio-one-time ?checked=${!!(this.startSubscription === false && this.product.requires_selling_plan === false)}>
          <label class="skio-group-label" for="skio-one-time-${this.key}">
            <div class="skio-group-topline">
              <div class="skio-radio__container">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="11" stroke="currentColor"></circle>
                  <circle class="skio-radio" cx="12" cy="12" r="5" fill="currentColor"></circle>
                </svg>
              </div>
              One-time Purchase
              <div class="skio-price">
                <span skio-onetime-price>${this.moneyFormatter.format(this.selectedVariant.price / 100).toString().split('.')[0]}
                  <span class="decimals">${this.moneyFormatter.format(this.selectedVariant.price / 100).toString().split('.')[1]}</span>
                </span>
              </div>
            </div>
          </label>
        </div>
        ${this.availableSellingPlanGroups
                ? this.availableSellingPlanGroups.map((group, index) =>
                    html`
            <div class="skio-group-container skio-group-container--available ${this.selectedSellingPlanGroup != null ? 'skio-group-container--selected' : ''}" skio-group-container
              @click=${() => this.selectSellingPlanGroup(group)}>
              <input id="skio-selling-plan-group-${index}-${this.key}" class="skio-group-input" name="skio-group-${this.key}"
                type="radio" value="${group.id}" skio-selling-plan-group="${group.id}" ?checked=${this.selectedSellingPlanGroup === group} >
              <label class="skio-group-label" for="skio-selling-plan-group-${index}-${this.key}">
                <div class="skio-group-topline">
                  <div class="skio-radio__container">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="11" stroke="currentColor"></circle>
                      <circle class="skio-radio" cx="12" cy="12" r="5" fill="currentColor"></circle>
                    </svg>
                  </div>
                  <div class="skio-group-title">
                    ${group.name === 'Subscription' ? 'Subscribe' : group.name}
                    ${this.discount(group.selected_selling_plan).percent !== '0%'
                            ? html`
                      <span class="skio-save">& Save <span skio-discount>${this.discountFormat === 'percent' ? this.discount(group.selected_selling_plan).percent : this.discount(group.selected_selling_plan).amount}</span></span>
                    `
                            : html``}
                  </div>
                  <div class="skio-price">
                  <span skio-subscription-price>
                    ${this.price(group.selected_selling_plan).toString().split('.')[0]}
                    <span class="decimals">${this.price(group.selected_selling_plan).toString().split('.')[1]}</span>
                  </span>
                  </div>
                </div>
                <div class="skio-group-content">
                  <select skio-selling-plans="${group.id}" class="skio-frequency"
                    @change=${(e) => this.selectSellingPlan(e.target, group)}>
                    ${group
                            ? group.selling_plans.map((sellingPlan) =>
                                html`
                      <option value="${sellingPlan.id}" data-value="${this.selectedSellingPlanId}" ?selected=${this.selectedSellingPlan?.id === sellingPlan.id}>
                        ${group.name === 'Subscription' ? `Delivery ${sellingPlan.name.toLowerCase()}` : `${sellingPlan.name}`}
                      </option>
                      `
                            )
                            : ''}
                  </select>
                </div>
              </label>
            </div>
            
            ${this.showAddToCartButton
                            ? html`
              <button @click=${() => this.addToCart()} class="add-to-cart">Add to Cart</button>
            `
                            : html``}

          `
                )
                : ''}
      </fieldset>`
  }

  updated = (changed) => {
    if (changed.has('product') && this.product) {
      // update key
      this.key = this.key ? this.key : this.product.id

      // update skioSellingPlanGroups
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        sellingPlanGroup => sellingPlanGroup.app_id === 'SKIO'
      )

      this.skioSellingPlanGroups.forEach((group) => {
        group.selling_plans.sort((a, b) => {
          let returnVal = 0

          if (parseInt(a.name.replace(/\D/g, '')) < parseInt(b.name.replace(/\D/g, ''))) returnVal = -1
          if (parseInt(a.name.replace(/\D/g, '')) > parseInt(b.name.replace(/\D/g, ''))) returnVal = 1
          if (parseInt(a.name.replace(/\D/g, '')) === parseInt(b.name.replace(/\D/g, ''))) returnVal = 0

          return returnVal
        })
      })
    }

    if (changed.has('selectedVariant') && this.selectedVariant) {
      // update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      const skioSellingPlanGroups = JSON.parse(JSON.stringify(this.skioSellingPlanGroups))
      this.availableSellingPlanGroups = skioSellingPlanGroups.filter(sellingPlanGroup =>
        sellingPlanGroup.selling_plans.some(sellingPlan =>
          this.selectedVariant.selling_plan_allocations.some(
            sellingPlanAllocation => sellingPlanAllocation.selling_plan_id === sellingPlan.id
          )
        )
      )

      // update selectedSellingPlan value
      if (this.availableSellingPlanGroups?.length > 0) {
        // update each group with a default selected_selling_plan

        this.availableSellingPlanGroups.forEach((group) => {
          group.selling_plans = group.selling_plans.filter(x => this.selectedVariant.selling_plan_allocations.find(y => y.selling_plan_id === x.id))
        })

        this.availableSellingPlanGroups.forEach(group => {
          if (this.defaultFrequency) {
            const sellingPlan = group.selling_plans.find(x => x.name.toLowerCase().includes(this.defaultFrequency.toLowerCase()))
            if (sellingPlan) group.selected_selling_plan = sellingPlan
            else group.selected_selling_plan = group.selling_plans[0]
          } else {
            group.selected_selling_plan = group.selling_plans[0]
          }
        })

        if (this.startSubscription === true || this.product.requires_selling_plan === true || this.purchaseOption === 'subscription') {
          // find a matching selling plan, or choose first available

          if (this.selectedSellingPlan === null || this.selectedSellingPlan === undefined) {
            this.selectSellingPlanGroup(this.availableSellingPlanGroups[0])
          }

          const sellingPlanName = this.selectedSellingPlan?.name

          const sellingPlanGroup = this.availableSellingPlanGroups.find(x => x.selling_plans.find(y => y.name === sellingPlanName))
          const sellingPlan = sellingPlanGroup?.selling_plans.find(y => y.name === sellingPlanName)
          if (sellingPlanName === sellingPlan?.name) {
            this.selectedSellingPlanGroup = sellingPlanGroup
            this.selectedSellingPlan = sellingPlan
          } else {
            this.selectedSellingPlanGroup = this.availableSellingPlanGroups[0]
            this.selectedSellingPlan = this.availableSellingPlanGroups[0].selling_plans[0]
          }
        } else {
          this.selectedSellingPlan = null
          this.selectedSellingPlanGroup = null
        }
      } else {
        this.selectedSellingPlan = null
        this.selectedSellingPlanGroup = null
      }

      // update the form that was passed, if any
      this.updateForm()
    }
  }

  log = (...args) => {
    args.unshift('%c[skio]', 'color: #8770f2;')
    console.log.apply(console, args)
  }

  error = (...args) => {
    args.unshift('%c [skio]', 'color: #ff0000')
    console.error.apply(console, args)
  }

  getMetadata (field) {
    const meta = this.meta
    if (typeof meta !== 'object') {
      const fieldData = meta[field]
      if (fieldData) return fieldData
      else return ''
    }
  }

  updateExternalPrice () {
    document.querySelectorAll(this.externalPriceSelector).forEach((el) => {
      // this.selectedSellingPlan ? el.innerHTML = this.price(this.selectedSellingPlan) : el.innerHTML = this.money( this.selectedVariant.price);
      let priceValue, priceValuefloat

      if (this.selectedSellingPlan) {
        priceValue = this.price(this.selectedSellingPlan).replace(/[^0-9.]/g, '')
        priceValuefloat = parseFloat(priceValue).toFixed(2)
        priceValuefloat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(priceValuefloat)
        el.innerHTML = `${priceValuefloat.split('.')[0]}<span class="decimals">${priceValuefloat.split('.')[1]}</span>`
      } else {
        priceValue = this.money(this.selectedVariant.price).replace(/[^0-9.]/g, '')
        priceValuefloat = parseFloat(priceValue).toFixed(2)
        priceValuefloat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(priceValuefloat)
        el.innerHTML = `${priceValuefloat.split('.')[0]}<span class="decimals">${priceValuefloat.split('.')[1]}</span>`
      }
      const priceNumeric = parseFloat(priceValue) * 100
      el.setAttribute('data-price', priceNumeric)
    })
    document.querySelectorAll(this.externalPriceSelectorWithCurrency).forEach((el) => {
      let priceValue, priceValuefloat

      if (this.selectedSellingPlan) {
        priceValue = this.price(this.selectedSellingPlan).replace(/[^0-9.]/g, '')
        priceValuefloat = parseFloat(priceValue).toFixed(2)
        priceValuefloat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(priceValuefloat)
        el.innerHTML = `${priceValuefloat.split('.')[0]}<span class="decimals">${priceValuefloat.split('.')[1]}</span>`
      } else {
        priceValue = this.money(this.selectedVariant.price).replace(/[^0-9.]/g, '')
        priceValuefloat = parseFloat(priceValue).toFixed(2)
        priceValuefloat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(priceValuefloat)
        el.innerHTML = `${priceValuefloat.split('.')[0]}<span class="decimals">${priceValuefloat.split('.')[1]}</span>`
      }
      const priceNumeric = parseFloat(priceValue) * 100
      el.setAttribute('data-price', priceNumeric)
    })
  }

  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup (group, emit = true) {
    this.selectedSellingPlanGroup = group
    this.selectedSellingPlan = group?.selected_selling_plan
    this.selectedSellingPlanId = group?.selected_selling_plan?.id
    if (group) this.purchaseOption = 'subscription'
    else this.purchaseOption = 'onetime'

    if (emit) {
      if (!this.isMobile) {
        const eventSelectSellingPlanGroup = new CustomEvent('skio-pdp-select-selling-plan-group', {
          detail: { group: this.selectedSellingPlanGroup, selling_plan: this.selectedSellingPlan },
          bubbles: true,
          composed: true
        })
        this.dispatchEvent(eventSelectSellingPlanGroup)
      } else {
        const eventSelectSellingPlanGroup = new CustomEvent('skio-sticky-mobile-select-selling-plan-group', {
          detail: { group: this.selectedSellingPlanGroup, selling_plan: this.selectedSellingPlan },
          bubbles: true,
          composed: true
        })
        this.dispatchEvent(eventSelectSellingPlanGroup)
      }
    }

    // update the form that was passed, if any
    this.updateForm()

    const skioPriceUpdate = new CustomEvent('skio-price-update', {
      detail: { group: this.selectedSellingPlanGroup, selling_plan: this.selectedSellingPlan },
      bubbles: true,
      composed: true
    })
    this.dispatchEvent(skioPriceUpdate)
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan (element, group, emit = true) {
    let sellingPlan = null
    if (element.value !== undefined) {
      sellingPlan = group.selling_plans.find(x => x.id === element.value)
    } else {
      sellingPlan = group.selling_plans.find(x => x.id === element.id)
    }
    if (sellingPlan) {
      group.selected_selling_plan = sellingPlan
      this.selectedSellingPlanGroup = group
      this.selectedSellingPlan = sellingPlan
      this.selectedSellingPlanId = sellingPlan.id
      if (emit) {
        if (!this.isMobile) {
          const eventSelectSellingPlanGroup = new CustomEvent('skio-pdp-select-selling-plan-group', {
            detail: { group, sellingPlan },
            bubbles: true,
            composed: true
          })
          this.dispatchEvent(eventSelectSellingPlanGroup)
        } else {
          const eventSelectSellingPlanGroup = new CustomEvent('skio-sticky-mobile-select-selling-plan-group', {
            detail: { group, sellingPlan },
            bubbles: true,
            composed: true
          })
          this.dispatchEvent(eventSelectSellingPlanGroup)
        }
      }
    } else this.log("Error: couldn't find selling plan with id " + element.value + ' for variant ' + this.selectedVariant.id + ' from product ' + this.product.id + ' : ' + this.product.handle)
  }

  // Formats integer value into money value
  money (price) {
    return this.moneyFormatter.format(price / 100.0)
  }

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount (sellingPlan) {
    if (!sellingPlan) { return { percent: '0%', amount: 0 } }

    if (sellingPlan.name.includes('prepaid')) {
      const option = sellingPlan.options[0].value

      const numberPattern = /\d+/g
      const result = parseInt(option.match(numberPattern).join(''))

      const priceAdjustment = sellingPlan.price_adjustments[0]
      const discount = { percent: '0%', amount: 0 }
      const price = this.selectedVariant.price * result

      switch (priceAdjustment.value_type) {
        case 'percentage':
          discount.percent = `${priceAdjustment.value}%`
          discount.amount = Math.round(
            (price * priceAdjustment.value) / 100.0
          )
          break
        case 'fixed_amount':
          discount.percent = `${Math.round(
                        ((priceAdjustment.value * 1.0) / price) * 100.0
                    )}%`
          discount.amount = price - priceAdjustment.value
          break
        case 'price':
          discount.percent = `${Math.round(
                        (((price - priceAdjustment.value) * 1.0) /
                            price) *
                        100.0
                    )}%`
          discount.amount = price - priceAdjustment.value
          break
      }

      return discount
    } else {
      const priceAdjustment = sellingPlan.price_adjustments[0]
      const discount = { percent: '0%', amount: 0 }
      const price = this.selectedVariant.price

      switch (priceAdjustment.value_type) {
        case 'percentage':
          discount.percent = `${priceAdjustment.value}%`
          discount.amount = Math.round(
            (price * priceAdjustment.value) / 100.0
          )
          break
        case 'fixed_amount':
          discount.percent = `${Math.round(
                        ((priceAdjustment.value * 1.0) / price) * 100.0
                    )}%`
          discount.amount = priceAdjustment.value
          break
        case 'price':
          discount.percent = `${Math.round(
                        (((price - priceAdjustment.value) * 1.0) /
                            price) *
                        100.0
                    )}%`
          discount.amount = price - priceAdjustment.value
          break
      }

      return discount
    }
  }

  // Calculates the variant's price for the given selling plan, returns a formatted money value (if desired)
  price (sellingPlan, formatted = true) {
    if (sellingPlan.name.includes('prepaid')) {
      const option = sellingPlan.options[0].value
      const numberPattern = /\d+/g
      const result = parseInt(option.match(numberPattern).join(''))

      return formatted
        ? this.money((this.selectedVariant.price * result) - this.discount(sellingPlan).amount)
        : (this.selectedVariant.price * result) - this.discount(sellingPlan).amount
    } else {
      return formatted
        ? this.money(this.selectedVariant.price - this.discount(sellingPlan).amount)
        : this.selectedVariant.price - this.discount(sellingPlan).amount
    }
  }

  // If a formId was passed, appends the necessary <input> elements to the form
  updateForm () {
    if (this.formId) {
      const form = document.querySelector(`#${this.formId}`)

      if (form) {
        let sellingPlanInput = form.querySelector('[name="selling_plan"]')
        if (sellingPlanInput) {
          sellingPlanInput.value = this.selectedSellingPlan?.id !== undefined ? this.selectedSellingPlan?.id : null
          sellingPlanInput.disabled = this.selectedSellingPlan?.id === undefined
        } else {
          sellingPlanInput = document.createElement('input')
          sellingPlanInput.type = 'hidden'
          sellingPlanInput.name = 'selling_plan'
          sellingPlanInput.value = this.selectedSellingPlan?.id !== undefined ? this.selectedSellingPlan?.id : null
          sellingPlanInput.disabled = this.selectedSellingPlan?.id === undefined
          form.append(sellingPlanInput)
        }

        let discountInput = form.querySelector('[name="properties[Discount]"]')
        if (discountInput) {
          discountInput.value = this.selectedSellingPlan?.id !== undefined ? this.discount(this.selectedSellingPlan).percent : null
          discountInput.disabled = this.selectedSellingPlan?.id === undefined
        } else {
          discountInput = document.createElement('input')
          discountInput.type = 'hidden'
          discountInput.name = 'properties[Discount]'
          discountInput.value = this.selectedSellingPlan?.id !== undefined ? this.discount(this.selectedSellingPlan).percent : null
          discountInput.disabled = this.selectedSellingPlan?.id === undefined
          form.append(discountInput)
        }
      } else {
        console.log(`Skio error: form ID is ${this.formId}, but no form with that ID was found.`)
      }
    }
  }

  // Optional functions keep if necessary

  /**
     *
     *
     */

  // Runs a fetch request to add the selectedVariant to the cart with the passed quantity and selectedSellingPlan
  addToCart (quantity = 1) {
    const items = [
      {
        id: this.selectedVariant.id,
        quantity,
        ...(this.selectedSellingPlan && { selling_plan: this.selectedSellingPlan?.id })
      }
    ]

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
      .then((response) => response.json())
      .then((response) => {
        this.log('SKIO added item to cart: ', response)
        // dispatch CustomEvent to tell document that an item was added to cart
        const event = new CustomEvent('skio::added-to-cart', {
          bubbles: true,
          composed: true,
          detail: {
            response,
            key: this.key
          }
        })

        this.dispatchEvent(event)
      })
      .catch((error) => {
        this.error(`SKIO ${this.key} error adding item to cart: `, error)
      })
  }

  addToCartMeta () {
    const items = []

    const quantityEl = document.querySelector(`input[name="quantity"][form="${this.formId}"]`)
    let quantity = 1
    if (quantityEl) {
      quantity = quantityEl.value
    }

    const variants = this.meta.variants
    const variantMeta = variants.find(x => x.variantId === this.selectedVariant.id)

    const code = variantMeta.discount
    const meta = variantMeta.addToCart
    meta.forEach((item) => {
      const i = {
        id: item.variantId,
        quantity: parseInt(item.quantity) * quantity
      }
      if (item.selling_plan !== 'null' && item.selling_plan !== null) {
        i.selling_plan = parseInt(item.selling_plan)
      }
      items.push(i)
    })

    const cart = document.querySelector('cart-drawer')
    let sections
    let sectionsUrl
    if (cart) {
      sections = cart.getSectionsToRender().map((section) => section.id)
      sectionsUrl = window.location.pathname
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items,
        ...(sections && { sections }),
        ...(sectionsUrl && { sectionsUrl })
      })
    })
      .then((response) => response.json())
      .then((response) => {
        this.log('SKIO META added item to cart: ', response)
        // dispatch CustomEvent to tell document that an item was added to cart
        const event = new CustomEvent('skio::added-to-cart', {
          bubbles: true,
          composed: true,
          detail: {
            response,
            key: this.key
          }
        })

        this.dispatchEvent(event)

        if (cart) {
          cart.renderContents(response)
          cart.classList.toggle('is-empty')
          cart.classList.toggle('active')
        }

        if (code) {
          window.location.href = '/checkout?discount=' + code
        } else {
          window.location.href = '/checkout'
        }
      })
      .catch((error) => {
        this.error(`SKIO META ${this.key} error adding item to cart: `, error)
      })
  }

  fetchProduct = (handle) => {
    return fetch(`/products/${handle}.js`)
      .then((response) => response.json())
      .then((product) => {
        this.product = product
        this.selectedVariant = product.variants[0]

        return product
      })
  }
}

customElements.define('skio-plan-picker', SkioPlanPickerComponent)
